<div class="fresh-air">
  <div class="container">
    <div class="graphic_logo"></div>
    <div *ngIf="skyClub.fullPageError$ | ngrxPush as fullPageError">
      <div
        [error]="fullPageError.error"
        (action)="redirect($event, 'button')"
        auraSkeletonLoader
      ></div>
      <ng-container *ngIf="!fullPageError.error">
        <idp-sky-club-page
          *ngIf="{
            overview: (skyClub.overview$ | ngrxPush) || emptyOverview,
            purchase: (skyClub.purchase$ | ngrxPush) || emptyPurchase,
            checkout: (skyClub.checkout$ | ngrxPush) || emptyCheckout,
            isLoggedIn: (skyClub.isLoggedIn$ | ngrxPush) || false
          } as content"
          [content]="content"
          (addToCart)="addToCart($event, content.purchase)"
          (checkOut)="checkOut(content.purchase)"
          (previousButton)="previousButton()"
          (returnToSkyClub)="returnToSkyClub()"
        ></idp-sky-club-page>
      </ng-container>
    </div>
  </div>
</div>
